/* eslint-disable @typescript-eslint/naming-convention */
export enum ImageSizeEnum {
    thumbnail,
    fullWidth
}
